import { Layout } from 'react-admin';
import { MySidebar } from '../sidebar/Sidebar';
import { MyMenu } from '../menu/Menu';
import Appbar from '../appbar/Appbar';
import { ScrollToTop } from './ScrollToTop';
import { AdminAlertHost } from '../admin-alert/AdminAlertHost';

/* ScrollToTop siedzi tutaj, bo Layout opakowuje kazdy routowany ekran i jest juz
   wewnatrz kontekstu routera — jedno miejsce zamiast haka w kazdej stronie. */
export const MyLayout = (props: any) => (
  <>
    <ScrollToTop />
    <AdminAlertHost />
    <Layout {...props} sidebar={MySidebar} menu={MyMenu} appBar={Appbar} />
  </>
);
